// extracted by mini-css-extract-plugin
export default {"mainWrapper":"SLCEachSkill_mainWrapper__s-YUU"};